'use strict';
import Barba from 'barba.js'
import Env from '../base/env.js'
import Channels from '../base/channels'
import Preload from '../components/works/Preload';
import WorkspaceList from '../components/works/List'
import WorkspaceGrid from '../components/works/Grid'
import WorkspaceDispatch from '../components/works/Dispatch'
import Switcher from '../components/works/Switcher'
import raf from 'raf'
import 'babel-polyfill'

let page

class Page
{
    constructor(view='')
    {
        // DOM
        this.view = view
        this.$list = this.view.querySelector('.jsList--view')
        this.$listItems = this.$list.querySelectorAll('.jsItem')
        this.$grid = this.view.querySelector('.jsGrid--view')
        this.$gridItems = this.$grid.querySelectorAll('.jsItem')
        this.$receptorGrid = this.view.querySelector('.jsDispatch--receptorGrid')
        this.$receptorGridMobile = this.view.querySelector('.jsDispatch--receptorGridMobile')
        this.$receptorList = this.view.querySelector('.jsDispatch--receptorList')
        // Vars
        this.classView = 'currentView--works'
        // Objects
        this.raf = undefined
        // Fns
        this.workspaceGrid = new WorkspaceGrid(this)
        this.workspaceList = new WorkspaceList(this)
        this.dispatch = new WorkspaceDispatch(this.view)
        this.switcher = new Switcher(this.view)
        this.funcClean = this.clean.bind(this)
        this.funcRender = this.render.bind(this)
        this.setup()
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    clean()
    {
        const cells = this.$receptorGrid.querySelectorAll('.cell')
        this.$receptorGridMobile.innerHTML = ''
        this.$receptorList.innerHTML = ''
        cells[0].innerHTML = ''
        cells[1].innerHTML = ''
        this.$listItems = []
        this.$gridItems = []
    }

    destroy()
    {
        raf.cancel(this.raf)
        this.workspaceList.destroy()
        this.workspaceGrid.destroy()
        this.dispatch.destroy()
        Channels.removeListener('launcher::exit', this.funcLaunch);
        Channels.removeListener('works::clean', this.funcClean);
        Channels.removeListener('works::render', this.funcRender);
    }

    events()
    {
        Channels.on('works::clean',this.funcClean)
        Channels.on('works::render',this.funcRender)
    }

    finalize()
    {
        this.watcher()
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 100);
    }

    intro()
    {
        this.switcher.detect()
        TweenLite.fromTo(this.view.querySelector('.fxSwitch') , 1 , { x : 90 } , { x : 0 , ease : Power3.easeOut })
        TweenLite.fromTo(this.view.querySelector('.fxFilter') , 1 , { x : -90 } , { x : 0 , ease : Power3.easeOut })
    }

    refresh()
    {
        this.workspaceList.refresh(this.$listItems)
        this.workspaceGrid.refresh(this.$gridItems)
    }

    render()
    {
        this.setVars()
    }

    setup()
    {
        this.workspaceGrid.enableMousemove()
        this.preloadListVisuals = new Preload({ view : this.view.querySelector('.jsList--visual') ,  items : this.$listItems , onComplete:()=>{
                this.workspaceList.enableMousemove()
                this.workspaceList.eventsItems()
                this.events()
            }
        })
    }

    setVars()
    {
        this.$listItems = this.$list.querySelectorAll('.jsItem')
        this.$gridItems = this.$grid.querySelectorAll('.jsItem')
        this.refresh()
    }

    watcher()
    {
        this.raf = raf(()=>{
            this.watcher()
        })

        if(Env.mobile === true) {
            this.dispatch.onWatch()
        }
        this.workspaceGrid.onWatch()
        this.workspaceList.onWatch()
    }
}

page = Barba.BaseView.extend({
    namespace: 'works',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;